const verificationI18n = {
  "fr": {
    "title": "Vérification",
    "back": "Retour",
    "loading": "Chargement…",
    "empty": "Aucune donnée.",
    "client": "Client",
    "chips": {
      "received": "Reçues :",
      "ok": "OK :",
      "ko": "KO :",
      "totalBuyback": "Total rachat :"
    },
    "commentLabel": "Commentaire (optionnel)",
    "counters": {
      "receivedLabel": "Pièces reçues",
      "verifiedLabel": "Pièces vérifiées (OK)",
      "unitPcs": "pcs"
    },
    "items": {
      "sectionTitle": "Articles (contrôle unitaire)",
      "unitPrice": "PU",
      "qty": "Qté",
      "buyQtyLabel": "Qté rachetée",
      "colProduct": "Nom du produit",
      "colGrade": "Grade (A/B/C/X)",
      "colPrice": "Prix",
      "unitHint": "Chaque pièce est listée séparément. Le grade “X” exclut la pièce."
    },
    "actions": {
      "submit": "Valider la vérification & générer le PDF",
      "openPdf": "Ouvrir le PDF"
    },
    "errors": {
      "load": "Chargement impossible.",
      "verify": "Échec de la vérification."
    },
    "success": {
      "saved": "Vérification enregistrée. PDF généré."
    }
  },
  "en": {
    "title": "Verification",
    "back": "Back",
    "loading": "Loading…",
    "empty": "No data.",
    "client": "Client",
    "chips": {
      "received": "Received:",
      "ok": "OK:",
      "ko": "KO:",
      "totalBuyback": "Total buyback:"
    },
    "commentLabel": "Comment (optional)",
    "counters": {
      "receivedLabel": "Items received",
      "verifiedLabel": "Items verified (OK)",
      "unitPcs": "pcs"
    },
    "items": {
      "sectionTitle": "Items (per-unit control)",
      "unitPrice": "Unit",
      "qty": "Qty",
      "buyQtyLabel": "Buyback qty",
      "colProduct": "Product name",
      "colGrade": "Grade (A/B/C/X)",
      "colPrice": "Price",
      "unitHint": "Each piece is listed separately. Grade “X” excludes the piece."
    },
    "actions": {
      "submit": "Confirm verification & generate PDF",
      "openPdf": "Open PDF"
    },
    "errors": {
      "load": "Unable to load.",
      "verify": "Verification failed."
    },
    "success": {
      "saved": "Verification saved. PDF generated."
    }
  },
  "pl": {
    "title": "Weryfikacja",
    "back": "Powrót",
    "loading": "Ładowanie…",
    "empty": "Brak danych.",
    "client": "Klient",
    "chips": {
      "received": "Odebrane:",
      "ok": "OK:",
      "ko": "KO:",
      "totalBuyback": "Suma wykupu:"
    },
    "commentLabel": "Komentarz (opcjonalnie)",
    "counters": {
      "receivedLabel": "Sztuk odebranych",
      "verifiedLabel": "Sztuk zweryfikowanych (OK)",
      "unitPcs": "szt."
    },
    "items": {
      "sectionTitle": "Pozycje (kontrola jednostkowa)",
      "unitPrice": "Cena j.",
      "qty": "Ilość",
      "buyQtyLabel": "Ilość do wykupu",
      "colProduct": "Nazwa produktu",
      "colGrade": "Ocena (A/B/C/X)",
      "colPrice": "Cena",
      "unitHint": "Każdy egzemplarz jest listowany osobno. Ocena „X” wyklucza sztukę."
    },
    "actions": {
      "submit": "Zatwierdź weryfikację i wygeneruj PDF",
      "openPdf": "Otwórz PDF"
    },
    "errors": {
      "load": "Nie udało się załadować.",
      "verify": "Weryfikacja nie powiodła się."
    },
    "success": {
      "saved": "Zapisano weryfikację. Wygenerowano PDF."
    }
  },
  "es": {
    "title": "Verificación",
    "back": "Volver",
    "loading": "Cargando…",
    "empty": "Sin datos.",
    "client": "Cliente",
    "chips": {
      "received": "Recibidas:",
      "ok": "OK:",
      "ko": "KO:",
      "totalBuyback": "Total recompra:"
    },
    "commentLabel": "Comentario (opcional)",
    "counters": {
      "receivedLabel": "Piezas recibidas",
      "verifiedLabel": "Piezas verificadas (OK)",
      "unitPcs": "uds"
    },
    "items": {
      "sectionTitle": "Artículos (control unitario)",
      "unitPrice": "PU",
      "qty": "Cant.",
      "buyQtyLabel": "Cant. recomprada",
      "colProduct": "Nombre del producto",
      "colGrade": "Grado (A/B/C/X)",
      "colPrice": "Precio",
      "unitHint": "Cada pieza se muestra por separado. El grado “X” excluye la pieza."
    },
    "actions": {
      "submit": "Validar verificación y generar PDF",
      "openPdf": "Abrir PDF"
    },
    "errors": {
      "load": "No se pudo cargar.",
      "verify": "La verificación ha fallado."
    },
    "success": {
      "saved": "Verificación guardada. PDF generado."
    }
  },
  "it": {
    "title": "Verifica",
    "back": "Indietro",
    "loading": "Caricamento...",
    "empty": "Nessun dato.",
    "client": "Cliente",
    "chips": {
      "received": "Ricevuto:",
      "ok": "Ok.",
      "ko": "KO:",
      "totalBuyback": "Totale buyback:"
    },
    "commentLabel": "Commento (opzionale)",
    "counters": {
      "receivedLabel": "Articoli ricevuti",
      "verifiedLabel": "Articoli verificati (OK)",
      "unitPcs": "pc"
    },
    "items": {
      "sectionTitle": "Articoli (controllo per unità)",
      "unitPrice": "Unità",
      "qty": "Qty",
      "buyQtyLabel": "Acquistare qty",
      "colProduct": "Nome del prodotto",
      "colGrade": "Grado (A/B/C/X)",
      "colPrice": "Prezzo",
      "unitHint": "Ogni pezzo è elencato separatamente. Grado “X” esclude il pezzo."
    },
    "actions": {
      "submit": "Confermare la verifica & generare PDF",
      "openPdf": "Aprire il PDF"
    },
    "errors": {
      "load": "Incapace di caricare.",
      "verify": "La verifica è fallita."
    },
    "success": {
      "saved": "Verifica salvata. PDF generato."
    }
  },
  "de": {
    "title": "Überprüfung",
    "back": "Rücken",
    "loading": "Beladung...",
    "empty": "Keine Daten.",
    "client": "Kunde",
    "chips": {
      "received": "Empfangen:",
      "ok": "OK:",
      "ko": "KO:",
      "totalBuyback": "Rückkauf insgesamt:"
    },
    "commentLabel": "Anmerkung (fakultativ)",
    "counters": {
      "receivedLabel": "Erhaltene Posten",
      "verifiedLabel": "Artikel verifiziert (OK)",
      "unitPcs": "pcs"
    },
    "items": {
      "sectionTitle": "Positionen (Kontrolle pro Einheit)",
      "unitPrice": "Einheit",
      "qty": "Qty",
      "buyQtyLabel": "Rückkauf qty",
      "colProduct": "Produktbezeichnung",
      "colGrade": "Klasse (A/B/C/X)",
      "colPrice": "Preis",
      "unitHint": "Jedes Stück wird separat aufgeführt. Grade \"X\" schließt das Stück aus."
    },
    "actions": {
      "submit": "Verifizierung bestätigen & PDF generieren",
      "openPdf": "Open PDF"
    },
    "errors": {
      "load": "Unfähig zu laden.",
      "verify": "Die Überprüfung ist fehlgeschlagen."
    },
    "success": {
      "saved": "Verifizierung gespeichert. PDF generiert."
    }
  },
  "pt": {
    "title": "Verificação",
    "back": "Voltar",
    "loading": "Carregando...",
    "empty": "Não há dados.",
    "client": "Cliente",
    "chips": {
      "received": "Recebido:",
      "ok": "Está bem.",
      "ko": "KO:",
      "totalBuyback": "Total da recompra:"
    },
    "commentLabel": "Comentário (opcional)",
    "counters": {
      "receivedLabel": "Itens recebidos",
      "verifiedLabel": "Itens verificados (OK)",
      "unitPcs": "pcs"
    },
    "items": {
      "sectionTitle": "Itens (por unidade de controlo)",
      "unitPrice": "Unidade",
      "qty": "Qty",
      "buyQtyLabel": "Compra qty",
      "colProduct": "Denominação do produto",
      "colGrade": "Grau (A/B/C/X)",
      "colPrice": "Preço",
      "unitHint": "Cada peça é listada separadamente. Grau “X” exclui a peça."
    },
    "actions": {
      "submit": "Confirmar a verificação e gerar PDF",
      "openPdf": "Abrir PDF"
    },
    "errors": {
      "load": "Incapaz de carregar.",
      "verify": "A verificação falhou."
    },
    "success": {
      "saved": "Verificação salva. PDF gerado."
    }
  },
  "cs": {
    "title": "Ověřování",
    "back": "Zpět",
    "loading": "Nabíjím...",
    "empty": "Žádná data.",
    "client": "Klient",
    "chips": {
      "received": "Přijato:",
      "ok": "OK:",
      "ko": "KO:",
      "totalBuyback": "Nákup celkem:"
    },
    "commentLabel": "Komentář (nepovinné)",
    "counters": {
      "receivedLabel": "Přijaté položky",
      "verifiedLabel": "Ověřené položky (OK)",
      "unitPcs": "ks"
    },
    "items": {
      "sectionTitle": "Položky (řízení perjednotek)",
      "unitPrice": "Jednotka",
      "qty": "Qty",
      "buyQtyLabel": "Buyback qty",
      "colProduct": "Název produktu",
      "colGrade": "Třída (A / B / C / X)",
      "colPrice": "Cena",
      "unitHint": "Každý kus je uveden samostatně. Stupeň \"X\" vylučuje kus."
    },
    "actions": {
      "submit": "Potvrzení ověření a generování PDF",
      "openPdf": "Otevřít PDF"
    },
    "errors": {
      "load": "Nelze načíst.",
      "verify": "Ověření selhalo."
    },
    "success": {
      "saved": "Ověření zachráněno. Vygenerovaný PDF."
    }
  },
  "nl": {
    "title": "Verificatie",
    "back": "Terug",
    "loading": "Laden...",
    "empty": "Geen gegevens.",
    "client": "Client",
    "chips": {
      "received": "Ontvangen:",
      "ok": "Oké:",
      "ko": "KO:",
      "totalBuyback": "Totale terugbetaling:"
    },
    "commentLabel": "Opmerking (facultatief)",
    "counters": {
      "receivedLabel": "Ontvangen posten",
      "verifiedLabel": "Items geverifieerd (OK)",
      "unitPcs": "stuks"
    },
    "items": {
      "sectionTitle": "Posten (controle per eenheid)",
      "unitPrice": "Eenheid",
      "qty": "Aantal",
      "buyQtyLabel": "Terugkopen",
      "colProduct": "Productnaam",
      "colGrade": "Klasse (A/B/C/X)",
      "colPrice": "Prijs",
      "unitHint": "Elk stuk is apart vermeld. Graad X sluit het stuk uit."
    },
    "actions": {
      "submit": "Bevestig verificatie & genereren PDF",
      "openPdf": "PDF openen"
    },
    "errors": {
      "load": "Kan niet laden.",
      "verify": "Verificatie mislukt."
    },
    "success": {
      "saved": "Verificatie opgeslagen. PDF gegenereerd."
    }
  }
};

export default verificationI18n;
